import React from 'react';

export const RedUnefon1 = () => {
  return (
    <>
        <div className="txtRedes1">Por cada $10 obtienes 24 horas ilimitadas de:</div>
        <div className='unefon1'></div>
        <div className="txtRedes2">Min, SMS y MB ilimitados desde Mex a Mex y EUA; en datos aplica baja de velocidad</div>
    </>
  )
}
